import { useState } from "react";

export const useSorting = () => {
  const [sortBy] = useState<string>("id");
  const [sortOrder] = useState<string>("asc");
  return [sortBy, sortOrder];
};
